export default __webpack_public_path__ + "static/media/not-found.62336430.png";